import { render, staticRenderFns } from "./SettingsEnergyPrices.vue?vue&type=template&id=24c09cb5&"
import script from "./SettingsEnergyPrices.vue?vue&type=script&lang=js&"
export * from "./SettingsEnergyPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardText,VCardTitle,VContainer,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c09cb5')) {
      api.createRecord('24c09cb5', component.options)
    } else {
      api.reload('24c09cb5', component.options)
    }
    module.hot.accept("./SettingsEnergyPrices.vue?vue&type=template&id=24c09cb5&", function () {
      api.rerender('24c09cb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reports/SettingsEnergyPrices.vue"
export default component.exports